import { Link } from "react-router-dom";

export function ConstructionWordMark({ linked = false, showReadal = true }) {
  const Tag = linked ? Link : "section";
  const extra = linked ? { to: "/construction" } : {};

  return (
    <Tag className="rs-loud" aria-label="Readal Construction" {...extra}>
      <style>{`
        .rs-loud {
          position: relative;
          overflow: hidden;
          padding: 72px 0 36px;
          background: #f3b517;
          border-top: 1px solid #1D3145;
          text-decoration: none;
          color: #A7B3C2;
          display: block;
        }
        .rs-loud-word {
          font-family: var(--f-display, "Space Grotesk", sans-serif);
          font-weight: 800;
          font-size: 18vw;
          line-height: 0.82;
          letter-spacing: -0.04em;
          text-align: center;
          white-space: nowrap;
          user-select: none;
          background: linear-gradient(180deg, #000000 60%, rgba(159, 142, 11, 0.65));
          -webkit-background-clip: text;
          background-clip: text;
          color: transparent;
        }
        .rs-loud-word.sub {
          font-size: 8.4vw;
          letter-spacing: -0.035em;
        }
        .rs-loud-row {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          gap: 16px;
          margin-top: 18px;
          padding: 0 var(--gutter, 32px);
          font-size: 13px;
          color: #A7B3C2;
        }
        .rs-loud-row .tagline {
          text-align: right;
          font-family: "JetBrains Mono", "IBM Plex Sans", monospace;
          letter-spacing: 0.02em;
        }
        a.rs-loud:hover .rs-loud-word {
          background: linear-gradient(180deg, #ffffff 40%, #F3B517 100%);
          -webkit-background-clip: text;
          background-clip: text;
        }
        @media (max-width: 760px) {
          .rs-loud-word { font-size: 22vw; }
          .rs-loud-word.sub { font-size: 11vw; }
          .rs-loud-row {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
          }
          .rs-loud-row .tagline { text-align: left; }
        }
      `}</style>
      {showReadal ? <div className="rs-loud-word">READAL</div> : null}
      <div className="rs-loud-word sub">CONSTRUCTION</div>
      <div className="rs-loud-row">
        <span>Readal Construction</span>
        <span className="tagline">
          Construction · Renovation · Civil works · Turnkey
        </span>
      </div>
    </Tag>
  );
}
